/*
 * Copyright (C) 2023 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react'

export default function KinderPanda(props) {
  return (
    <svg
      width={144}
      height={177}
      viewBox="0 0 144 177"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M106.629 6.502c-2.857-.941-4.352-6.344.074-4.922 4.426 1.422 2.783 5.864-.074 4.922z"
        fill="#fff"
        stroke="#152633"
      />
      <path
        d="M121.477 37.823c-1.521 2.747-2.565 2.452-22.349-1.82L77.65 24.088l7-18.008c3.348-2.441 10.957-3.052 17.044-2.747 6.087.306 16.74 8.546 22.218 14.345 5.479 5.8-.913 17.397-2.435 20.144z"
        fill="#fff"
        stroke="#152633"
      />
      <path
        d="M121.478 37.823c-1.522 2.747-4.066 1.952-23.85-2.32l11.001-2 6-15.824c1-2.5-1.522-8.177-8.5-13.177 6.087 3 12.305 7.378 17.784 13.177 5.478 5.8-.914 17.397-2.435 20.144z"
        fill="#152633"
        stroke="#152633"
      />
      <path
        d="M79.129 6.002c-13.122 1.567-11 20-6 23 3-2 19.166.355 28.5 3-3.044-1.22-5-4.5-2.5-11.5s-7.218-16.026-20-14.5z"
        fill="#EDEDED"
      />
      <path
        d="M76.13 2.002c-13.122 1.567-11 20-6 23 2.999-2 17.666 1.855 27 4.5-3.044-1.22-4.286-6-1-13 3.284-7-7.218-16.026-20-14.5z"
        fill="#7BE8DF"
        stroke="#152633"
      />
      <path
        d="M75.63 7.002c-9.271 1.142-6.533 15.313-3 17.5 4 0 11.904 1.072 18.499 3-2.15-.89-2.762-5.265-.645-8.84 3.644-6.16-5.823-12.772-14.854-11.66z"
        stroke="#152633"
      />
      <path
        d="M74.63 12.002c-4.253 1.773-1.955 11.342 0 12.5 2.213 0 7.85.98 11.499 2-1.19-.47-1.761-4.066-.357-6.68 2.856-5.32-5.642-10.112-11.142-7.82z"
        stroke="#152633"
      />
      <path
        d="M119.629 39.002c-.513 1.813-14.081-.146-27.039-3.83-12.957-3.683-19.461-7.67-22.462-10.17 4.5-1 11.36-.079 24.318 3.605 12.958 3.684 25.696 8.582 25.183 10.395z"
        fill="#FEE28B"
        stroke="#152633"
      />
      <path
        d="M115.428 36.666c-.331 1.172-11.288-.714-21.83-3.712-10.543-2.997-18.82-6.377-18.489-7.55.332-1.173 9.147.306 19.69 3.303 10.542 2.997 20.961 6.786 20.629 7.959z"
        fill="#152633"
      />
      <path
        d="M87.07 114.503c8 4.5 17.002-1.001 23.5-4.001 10-2 4.998 59-21.501 25-7 0-11.961.287-1.998-20.999z"
        fill="#537FEE"
        stroke="#152633"
      />
      <path
        d="M27.346 107.01c6.45 8.674 10.283 16.555 12.722 24.993 1.5 2-16.304 12.568-20.5 15-5.5-5.501-12.212-14.001-15.5-23.5 3-2.5 5-5 3.288-8.766 5.17-3.849 11.832-6.424 19.99-7.727z"
        fill="#EF3E60"
      />
      <path
        d="M9.068 120.002c-2 1.5-3 2-4.5 3 1.5 5 6.7 16.7 15.5 23.5 9.6-4.4 17.333-10.833 20-13.5.167-1.333-3.8-12.5-5-12.5-5 14.5-16.5 24-26-.5z"
        fill="#E43154"
      />
      <path
        d="M27.346 107.01c6.45 8.674 10.284 16.054 12.723 24.492.95 3.289-16.088 12.9-20.498 15.5-4.999-4-14.5-18-15.502-23.5.653-.489 1.818-1.577 2.501-1.5 1.412.159 2.345 2.022 3.5 1.5-.713-2-2.578-8.115-2.5-9 5.169-3.848 11.619-6.189 19.776-7.492z"
        stroke="#152633"
      />
      <path
        d="M37.57 132.502c-2.002 3-14 9.5-18.002 11.5 0 0-9.998-11.5-13.998-25l2.5-2c4 14.5 11.498 23 11.498 23 5.002-2.5 11.502-6.5 18.002-7.5z"
        fill="#fff"
        stroke="#152633"
      />
      <path
        d="M26.89 115.886c-1.49 2.18 1.752 5.369 8.18 3.616 1.498 2.5 2.498 5 3.498 7 4.302 1.883 9.96-1.39 15.524-5.184.011-.584 1.169-2.922 1.753-4.09-1.753-1.169-3.506-2.922-3.845-4.373-13.728-2.084-23.618.852-25.11 3.031z"
        fill="#2D3B45"
      />
      <path
        d="M37.068 122.002c6.5 6 14-2.5 11-9.5l7.777 5.31c-2.591 4.32-6.504 6.739-11.277 8.69-6.174 2.525-7.5-4.5-7.5-4.5z"
        fill="#28343D"
      />
      <path
        d="M26.89 115.887c-1.49 2.179 1.178 5.365 7.178 4.615 4-.5 3.5 4 4.5 6 4.302 1.883 9.96-1.39 15.524-5.184.012-.584 1.169-2.921 1.753-4.09-1.753-1.169-3.506-2.922-3.845-4.373-13.727-2.084-23.618.852-25.11 3.032z"
        stroke="#152633"
      />
      <path
        d="M96.108 141.502c5.566 6.513 9.443 10.361 11.629 11.545 3.28 1.776.597 10.065-6.56 10.953-4.77.592-11.828-1.974-21.171-7.697l16.102-14.801z"
        fill="#2D3B45"
      />
      <path
        d="M105.068 151.002l-3.168-3c-6 7.848-18.5 10-18.5 10 9.344 5.723 15.668 6.5 20.668 5-8.5-1-13.5-3.5 1-12z"
        fill="#28343D"
      />
      <path
        d="M96.108 141.502c5.566 6.513 9.443 10.361 11.629 11.545 3.28 1.776.597 10.065-6.56 10.953-4.77.592-11.828-1.974-21.171-7.697l16.102-14.801z"
        stroke="#152633"
      />
      <path
        d="M56.674 115.926c7.229 2.421 15.478 3.736 24.239 3.736 7.81 0 15.61 2.657 21.987.84-9.5 10 16.668 32-24.164 39.356-29.257 0-32.025-22.646-22.062-43.932z"
        fill="#fff"
      />
      <path
        d="M94.9 122.002c5.666 5.834 18.667 29-8.833 36.5 35-22-10.965-38.95-34-29.5 0-1.5 3.332-10.166 4.332-12l38.5 5z"
        fill="#EDEDED"
      />
      <path
        d="M98.568 140.502c-3-.5-9.5-5.5-3-8.5-.5-.5-3.4-3.5-5-3.5-6.8 11.2 2.166 15.334 7.5 16 .5-.833 1.3-2.8.5-4zM62.56 120.502c.74.325 2.519 1.291 3.008 1.5 0 0-1 11-14.5 16 0-.38.072-1.268.162-2.222 6.338-.778 11.33-10.778 11.33-15.278z"
        fill="#EDEDED"
      />
      <path
        d="M56.674 115.926c7.229 2.421 15.478 3.736 24.239 3.736 7.81 0 15.61 2.657 21.987.84-9.5 10 17.168 32-24.164 39.356-29.257 0-32.025-22.646-22.062-43.932z"
        stroke="#152633"
      />
      <path
        d="M101.57 147.502c-20.001-1.5-21-18.5-12.5-23 0 0 4 .5 7 0-11 10-5 18 6.5 19 0 1.5-.5 3-1 4z"
        fill="#6792FF"
      />
      <path
        d="M90.997 144.543c2.26.971 9.148 2.486 9.534-1.301.657.112 1.338.199 2.039.26-.001 1.5-.501 3-1.001 4-4.416-.331-7.906-1.418-10.572-2.959zM92.799 124.724c1.071.005 2.23-.049 3.27-.222-7.896 7.179-7 14.5 0 18-8-1-10.568-10.325-3.27-17.778z"
        fill="#537FEE"
      />
      <path
        d="M101.57 147.502c-20.001-1.5-21-18.5-12.5-23 0 0 4 .5 7 0-11 10-5 18 6.5 19 0 1.5-.5 3-1 4z"
        stroke="#152633"
      />
      <path
        d="M51.57 135.502c13.5-7 10.499-16 10.499-16-1.167-.5-3.7-1.6-4.5-2 1 5.5-1.5 11-5.5 12.5 0 0-.5 4.5-.5 5.5z"
        fill="#6792FF"
      />
      <path
        d="M60.11 118.653c.742.325 1.47.64 1.96.849 0 0 3 9-10.5 16 0-.38.072-1.268.162-2.222 10.115-6.234 8.676-13.497 8.379-14.627z"
        fill="#537FEE"
      />
      <path
        d="M51.57 135.502c13.5-7 10.499-16 10.499-16-1.167-.5-3.7-1.6-4.5-2 1 5.5-1.5 11-5.5 12.5 0 0-.5 4.5-.5 5.5z"
        stroke="#152633"
      />
      <path
        d="M60.903 145.502c-23-5-15.172 28.175 10.664 19.838 25.835-8.338 8.835-22.338-10.664-19.838z"
        fill="#2D3B45"
      />
      <path
        d="M84.696 155.144c-.063 3.441-3.808 7.187-13.13 10.196-18.327 5.914-27.593-9.062-23.22-16.481-.978 7.761 8.128 18.673 24.22 13.48 6.659-2.149 10.472-4.674 12.13-7.195z"
        fill="#28343D"
      />
      <path
        d="M51.065 152.518c.803-.119 1.333-1.03 1.184-2.034-.15-1.004-.922-1.721-1.725-1.602s-1.334 1.03-1.184 2.034c.15 1.004.921 1.721 1.725 1.602zM55.702 153.521c.794.07 1.508-.678 1.595-1.67.087-.993-.487-1.853-1.28-1.923-.794-.069-1.508.679-1.595 1.671-.087.992.486 1.853 1.28 1.922zM48.902 158.002c.5 3 4 7.25 12.999 8 12 1-14.833-19-13-8zM61.673 155.207c-.374.896-1.258 1.379-1.975 1.079-.716-.299-.993-1.267-.619-2.163.374-.895 1.258-1.378 1.974-1.079.717.3.994 1.268.62 2.163z"
        fill="#53636F"
      />
      <path
        d="M64.704 163.69c.753 1.528.156 2.559-2.804 2.312-9-.75-12.666-6-13-8-.244-1.465.02-2.38.635-2.868 2.263 4.594 7.507 8.613 15.17 8.556z"
        fill="#48555E"
      />
      <path
        d="M60.902 145.502c-23-5-15.172 28.175 10.663 19.838 25.836-8.338 8.836-22.338-10.663-19.838zM57.902 145.002c4.8.4 8 3.167 9 4.5"
        stroke="#152633"
      />
      <path
        d="M96.77 124.968c.957 1.1 9.337 12.934 17.69 17.302 11.078 5.794 16.108-6.231 13.55-12.239-2.386-5.604-20.298-7.924-29.025-7.392-2.494.445-3.171 1.228-2.215 2.329z"
        fill="#2D3B45"
      />
      <path
        d="M109.067 123.502c-1.999-1.5-14-1.475-11 3 2.74 4.088 8.039 11.4 16.392 15.768 3.974 2.079 7.169 1.864 9.516.457-7.064.495-24.407-14.058-14.908-19.225z"
        fill="#28343D"
      />
      <path
        d="M96.77 124.967c1.29 1.662 9.337 12.935 17.69 17.303 11.078 5.794 16.108-6.231 13.55-12.239-2.386-5.604-16.104-7.339-29.025-7.392-2.405-.009-3.044 1.261-2.215 2.328z"
        stroke="#152633"
      />
      <path
        d="M121.663 120.272c.061-.119.092-.179.13-.233a1.05 1.05 0 01.113-.135c.047-.047.1-.088.207-.169l6.9-5.278c.465-.356.698-.533.879-.525a.499.499 0 01.392.219c.102.151.072.442.011 1.024l-.877 8.423c-.012.112-.017.168-.029.223a1.064 1.064 0 01-.043.143c-.02.052-.046.102-.098.202l-11.93 23.098c-.516.999-.774 1.498-1.165 1.779a2.008 2.008 0 01-1.182.374c-.481-.004-.979-.265-1.976-.785l-1.886-.984c-.989-.516-1.484-.774-1.762-1.164a2.003 2.003 0 01-.372-1.175c.004-.479.26-.975.772-1.966l11.916-23.071z"
        fill="#F6C446"
      />
      <path
        d="M122.162 123.507l-.462-3.701 7.487-5.408a.5.5 0 01.792.428l-.415 9.143-4.164 1.388-.462-2.775-2.776.925z"
        fill="#F7D098"
      />
      <path
        d="M129.563 123.969s-4.495 3.033-4.995-.967l4.474-7.322c.271-.442.953-.232.926.286l-.405 8.003z"
        fill="#EFBD75"
      />
      <path
        d="M116.068 141.002l8.5-18 1 2 3.5-.5c-1.432 3.341-11.288 16.215-13 16.5z"
        fill="#E2AF2E"
      />
      <path
        d="M121.665 120.27c.061-.118.092-.177.13-.231a.919.919 0 01.113-.135c.047-.047.1-.087.206-.168l6.901-5.279c.465-.356.698-.533.879-.525a.5.5 0 01.392.219c.102.151.072.442.011 1.024l-.877 8.422a1.919 1.919 0 01-.029.223 1.036 1.036 0 01-.043.144c-.02.052-.046.103-.099.203l-12.085 23.321c-.516.997-.775 1.496-1.166 1.775a2 2 0 01-1.181.373c-.481-.004-.979-.264-1.974-.784l-1.886-.984c-.99-.516-1.485-.775-1.764-1.165a2.006 2.006 0 01-.371-1.177c.004-.479.261-.975.775-1.967l12.068-23.289z"
        stroke="#152633"
      />
      <path
        d="M109.864 142.987c.256-.503.385-.755.58-.896a.995.995 0 01.593-.189c.241.001.492.132.992.393l4.723 2.465c.492.257.738.385.877.579a1 1 0 01.187.585c-.001.239-.127.486-.379.981l-.283.554c-.513 1.007-.769 1.51-1.161 1.793-.345.248-.76.381-1.184.378-.484-.003-.984-.265-1.986-.787l-1.885-.984c-.985-.514-1.477-.771-1.755-1.159a2.005 2.005 0 01-.374-1.171c.002-.477.254-.971.758-1.961l.297-.581z"
        fill="#FF8686"
      />
      <path d="M114.377 143.521l3.78 1.972-2.47 4.844-3.78-1.972 2.47-4.844z" fill="#F46767" />
      <path
        d="M109.864 142.987c.257-.503.385-.755.581-.896a.996.996 0 01.592-.189c.241.001.492.132.993.393l4.722 2.465c.492.257.738.385.877.579.122.171.188.376.187.586-.001.238-.127.485-.379.98l-.282.554c-.514 1.007-.77 1.51-1.162 1.793a2.002 2.002 0 01-1.184.378c-.483-.003-.984-.265-1.986-.787l-1.885-.984c-.985-.514-1.477-.771-1.755-1.159a1.996 1.996 0 01-.373-1.17c.001-.478.253-.972.758-1.962l.296-.581zM121.7 119.806l.462 3.701 2.776-.925.462 2.775 4.164-1.388"
        stroke="#152633"
      />
      <path d="M126.326 116.568l3.7-2.776v4.626c-2.22.74-3.392-1.079-3.7-1.85z" fill="#152633" />
      <path
        d="M127.119 127.327c3.799 5.69 2.276 17.07-7.967 17.639-14.543-3.793-4.395-22.697 7.967-17.639z"
        fill="#2D3B45"
      />
      <path
        d="M128.423 133.845c-4.921 11.339-15.726 7.45-14.392-3.86-2.881 5.615-3.064 12.606 6.013 14.767 6.914-.864 8.644-6.915 8.379-10.907z"
        fill="#28343D"
      />
      <path
        d="M127.121 127.327c3.798 5.69 1.707 17.639-7.967 17.07-14.543-3.793-4.395-22.129 7.967-17.07z"
        stroke="#152633"
      />
      <path
        d="M130.476 68.798a19.044 19.044 0 005.031-1.854c6.827-3.655 7.107-11.803 7.077-13.859-.029-2.055-.645-12.01-8.984-9.044-5.385 1.915-11.3 5.78-14.817 8.28a55.77 55.77 0 0111.693 16.477z"
        fill="#2D3B45"
      />
      <path
        d="M121.754 50.289c-1.105.727-2.11 1.42-2.971 2.033a55.77 55.77 0 0111.693 16.476c4.38-.934 11.093-4.796 12.093-12.796-10.63 11.893-11.686 3.605-20.815-5.713z"
        fill="#28343D"
      />
      <path
        d="M130.476 68.798a19.044 19.044 0 005.031-1.854c6.827-3.655 7.107-11.803 7.077-13.859-.029-2.055-.645-12.01-8.984-9.044-5.385 1.915-11.3 5.78-14.817 8.28a55.77 55.77 0 0111.693 16.477z"
        stroke="#152633"
      />
      <path
        d="M49.783 47.015c.703.813 1.429 1.502 2.152 2.085 4.663-3.782 9.999-6.82 15.785-8.819-2.074-3.11-5.605-7.976-9.311-11.15-5.809-4.971-9.386 2.867-10.046 4.516-.66 1.648-2.956 8.307 1.42 13.368z"
        fill="#2D3B45"
      />
      <path
        d="M50.898 29.463c-5.184 5.673-4.953 14.806 1.037 19.637 4.663-3.782 9.999-6.82 15.785-8.819a87.338 87.338 0 00-1.209-1.766C56.25 42.867 42.932 45.363 50.9 29.463z"
        fill="#28343D"
      />
      <path
        d="M49.783 47.015c.703.813 1.429 1.502 2.152 2.085 4.663-3.782 9.999-6.82 15.785-8.819-2.074-3.11-5.605-7.976-9.311-11.15-5.809-4.971-9.386 2.867-10.046 4.516-.66 1.648-2.956 8.307 1.42 13.368z"
        stroke="#152633"
      />
      <path
        d="M33.677 78.717c-4.26 22.99 14.245 39.128 42.815 44.421 28.568 5.293 49.645-4.16 56.246-25.584 7.128-23.132-11.963-53.95-40.532-59.243-28.569-5.293-54.05 16.226-58.529 40.406z"
        fill="#fff"
      />
      <path
        d="M47.862 111.842c6.968 4.3 15.69 7.454 25.63 9.295 28.569 5.294 49.646-4.159 56.247-25.583 5.298-17.194-3.889-38.634-20.687-50.683 18.683 11.546 29.293 34.492 23.687 52.683-6.601 21.424-27.678 30.877-56.246 25.583-11.424-2.116-21.238-5.966-28.631-11.295z"
        fill="#EDEDED"
      />
      <path
        d="M33.677 78.717c-4.26 22.99 14.245 39.128 42.815 44.421 28.568 5.293 49.645-4.16 56.246-25.584 7.128-23.132-11.963-53.95-40.532-59.243-28.569-5.293-54.05 16.226-58.529 40.406z"
        stroke="#152633"
      />
      <path
        d="M71.56 98.964c.385-2.08-2.763-4.407-7.032-5.198-4.269-.79-8.042.254-8.427 2.334-.385 2.08 2.763 4.407 7.032 5.198 4.269.791 8.042-.254 8.427-2.334z"
        fill="#152633"
      />
      <path
        d="M63.069 100.002c-1 1.5 0 4.5 0 4.5m0 0c1.5 3 9.5 5 14.5 1m-14.5-1c-5 2.5-10.5-1.5-9.5-3.5"
        stroke="#152633"
      />
      <path
        d="M96.215 107.412c-10.082-1.867-18.722-15.17-16.448-27.449 2.543-13.726 13.183-26.06 21.96-24.434 4.369.81 8.98 5.073 12.239 11.446 3.298 6.446 4.593 13.927 3.474 19.968-2.42 13.063-12.013 22.176-21.225 20.469z"
        fill="#2D3B45"
        stroke="#152633"
      />
      <path
        d="M88.3 78.95c-2.325.241-3.902 3.4-3.523 7.053.379 3.654 2.572 6.42 4.897 6.18 2.325-.242 3.902-3.4 3.523-7.054-.38-3.654-2.572-6.42-4.897-6.179z"
        fill="#fff"
      />
      <path
        d="M58.71 87.109c-3.683 3.802-7.405 5.402-10.465 4.92a4.898 4.898 0 01-.155-.027c-2.185-.405-4.77-2.044-6.247-4.134-3.605-5.095-4.626-10.14-3.212-17.77 2.228-12.028 16.543-25.394 25.176-23.795 1.871.347 3.277 1.265 4.233 2.754 2.846 4.432 2.135 13.42-1.336 24.533-1.49 4.774-4.37 9.776-7.995 13.519z"
        fill="#2D3B45"
        stroke="#152633"
      />
      <path
        d="M52.272 77.074c-1.362 2.685-1.083 5.564.626 6.431 1.708.868 4.197-.605 5.56-3.29 1.363-2.684 1.083-5.563-.625-6.43-1.708-.868-4.198.605-5.56 3.29z"
        fill="#fff"
      />
      <path
        d="M78.07 112.502c-1.5 3-7.5-.5-8-4.5 2.998 0 4.498-.5 7.498-2.5-2.501 3 2.001 4 .501 7z"
        fill="#F49696"
        stroke="#152633"
      />
      <path
        d="M130.476 68.798a19.044 19.044 0 005.031-1.854c6.827-3.655 7.107-11.803 7.077-13.859-.029-2.055-.645-12.01-8.984-9.044-5.385 1.915-11.3 5.78-14.817 8.28a55.77 55.77 0 0111.693 16.477z"
        fill="#2D3B45"
      />
      <path
        d="M121.754 50.289c-1.105.727-2.11 1.42-2.971 2.033a55.77 55.77 0 0111.693 16.476c4.38-.934 11.093-4.796 12.093-12.796-10.63 11.893-11.686 3.605-20.815-5.713z"
        fill="#28343D"
      />
      <path
        d="M130.476 68.798a19.044 19.044 0 005.031-1.854c6.827-3.655 7.107-11.803 7.077-13.859-.029-2.055-.645-12.01-8.984-9.044-5.385 1.915-11.3 5.78-14.817 8.28a55.77 55.77 0 0111.693 16.477z"
        stroke="#152633"
      />
      <path
        d="M49.783 47.015c.703.813 1.429 1.502 2.152 2.085 4.663-3.782 9.999-6.82 15.785-8.819-2.074-3.11-5.605-7.976-9.311-11.15-5.809-4.971-9.386 2.867-10.046 4.516-.66 1.648-2.956 8.307 1.42 13.368z"
        fill="#2D3B45"
      />
      <path
        d="M50.898 29.463c-5.184 5.673-4.953 14.806 1.037 19.637 4.663-3.782 9.999-6.82 15.785-8.819a87.338 87.338 0 00-1.209-1.766C56.25 42.867 42.932 45.363 50.9 29.463z"
        fill="#28343D"
      />
      <path
        d="M49.783 47.015c.703.813 1.429 1.502 2.152 2.085 4.663-3.782 9.999-6.82 15.785-8.819-2.074-3.11-5.605-7.976-9.311-11.15-5.809-4.971-9.386 2.867-10.046 4.516-.66 1.648-2.956 8.307 1.42 13.368z"
        stroke="#152633"
      />
      <path
        d="M33.677 78.717c-4.26 22.99 14.245 39.128 42.815 44.421 28.568 5.293 49.645-4.16 56.246-25.584 7.128-23.132-11.963-53.95-40.532-59.243-28.569-5.293-54.05 16.226-58.529 40.406z"
        fill="#fff"
      />
      <path
        d="M70.87 113.248c1.13 1.141 2.207 1.759 3.174 1.793 1 .035 1.904-.554 2.684-1.751.426-.653.834-1.37 1.214-2.098-2.798-.075-5.296.479-7.071 2.056zm10.855-7.582c-.726 2.097-1.732 4.971-3.92 8.326-1.03 1.577-2.345 2.384-3.805 2.333a4.173 4.173 0 01-1.223-.234c-2.024-.7-4.128-2.956-6.274-6.721a22.996 22.996 0 01-4.923-1.088 13.836 13.836 0 01-1.383-.552c-.828-.446-.46-1.509.558-1.156.09.043 8.536 3.986 18.06-.602.029-.014 1.078-.42 1.97-1.066 1.11-.891 1.423-.638.94.76z"
        fill="#152633"
      />
      <path
        d="M47.862 111.842c58.205 30.16 117.205-16.34 61.19-66.97 18.683 11.545 29.293 34.49 23.687 52.682-6.601 21.424-27.678 30.877-56.246 25.583-11.424-2.116-21.238-5.966-28.631-11.295z"
        fill="#EDEDED"
      />
      <path
        d="M33.677 78.717c-4.26 22.99 14.245 39.128 42.815 44.421 28.568 5.293 49.645-4.16 56.246-25.584 7.128-23.132-11.963-53.95-40.532-59.243-28.569-5.293-54.05 16.226-58.529 40.406z"
        stroke="#152633"
      />
      <path
        d="M71.56 98.964c.385-2.08-2.763-4.407-7.032-5.198-4.269-.79-8.042.254-8.427 2.334-.385 2.08 2.763 4.407 7.032 5.198 4.269.791 8.042-.254 8.427-2.334z"
        fill="#152633"
      />
      <path
        d="M96.215 107.412c-10.082-1.867-18.722-15.17-16.448-27.449 2.543-13.726 13.183-26.06 21.96-24.434 4.369.81 8.98 5.073 12.239 11.446 3.298 6.446 4.593 13.927 3.474 19.968-2.42 13.063-12.013 22.176-21.225 20.469z"
        fill="#2D3B45"
        stroke="#152633"
      />
      <path
        d="M88.3 79.95c-2.325.241-3.902 3.4-3.523 7.053.379 3.654 2.572 6.42 4.897 6.18 2.325-.242 3.903-3.4 3.524-7.054-.38-3.654-2.572-6.42-4.898-6.179z"
        fill="#fff"
      />
      <path
        d="M58.71 87.109c-3.683 3.802-7.405 5.402-10.465 4.92a4.898 4.898 0 01-.155-.027c-2.185-.405-4.77-2.044-6.247-4.134-3.605-5.095-4.626-10.14-3.212-17.77 2.228-12.028 16.543-25.394 25.176-23.795 1.871.347 3.277 1.265 4.233 2.754 2.846 4.432 2.135 13.42-1.336 24.533-1.49 4.774-4.37 9.776-7.995 13.519z"
        fill="#2D3B45"
        stroke="#152633"
      />
      <path
        d="M52.272 77.074c-1.362 2.685-1.083 5.564.626 6.431 1.708.868 4.197-.605 5.56-3.29 1.363-2.684 1.083-5.563-.625-6.43-1.708-.868-4.198.605-5.56 3.29z"
        fill="#fff"
      />
    </svg>
  )
}
